(function () {
  'use strict';

  /* @ngdoc object
   * @name events.deposits
   * @description
   *
   */
  angular
    .module('events.deposits', [
      'ui.router',
      'events.deposits.list',
      'events.deposits.edit'
    ]);
}());
